<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="seizeTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="tab1-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab"
              aria-controls="tab1" @click="onClickTab('1')">
              {{ $t("content.amnseize") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="tab2-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab"
              aria-controls="tab2" @click="onClickTab('2')">
              {{ $t("content.historyseize") }}
            </button>
          </li>
        </ul>

        <div id="seizeTabContent" class="tab-content">
          <div id="tab1" class="tab-pane fade" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amnseize") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-6">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input type="text" v-model="tk_search" />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch-fn" color="primary" class="float-lg-start float-sm-end mb-3"
                        :disabled="tk_search === '' && cusName_search === ''" @click="loadDataApi">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ btnSearch }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelDataBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ cancel }}
                      </material-button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.lasttrf") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.transt") }}</th>
                          <th>{{ $t("content.amnweightvalall") }}</th>
                          <th>{{ $t("content.amnqtyunitall") }}</th>
                          <th>{{ $t("content.allprice") }}</th>
                          <th>{{ $t("content.statusticket") }}</th>
                          <th>{{ $t("content.amnlastmaker") }}</th>
                          <th class="align-top text-center">{{ $t("content.lostcount") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listdata" :key="index">
                          <td class="text-sm font-weight-normal">{{ formatNumberString((currentPage - 1) * perPage +
                            index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.customerName }}
                            </span>
                            <span v-else>
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal"> {{ checkTransaction(row.type) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.newPawnValue) }}</td>
                          <td class="text-sm font-weight-normal">{{ checkTicketStatus(row.status) }}</td>
                          <td class="text-sm font-weight-normal">{{ row.shopManagerName }}</td>
                          <td class="text-sm font-weight-normal text-center">{{ row.lostCount }}</td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal2" id="detailModal">
                            </material-button>
                            <material-button color="warning" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.historyview')"
                              :disabled="row.lostCount === 0" @click="viewHistory(row)">
                              <i class="material-icons material-symbols-outlined">navigate_next</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listdata.length === 0">
                          <td colspan="11" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="14" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listdata.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                          @click="onClickHandler" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div id="tab2" class="tab-pane fade" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.historyseize") }}</h5>
              </div>
              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-12 mb-4">
                    <div class="d-flex align-items-center w-100">
                      <label class="form-label m-0">{{ $t("content.item") }}</label>
                      <material-radio id="seize2" v-model="selectSeize" name="selLost" class="radio-horizon" value="0">
                        {{ $t("content.amnticketlost") }}
                      </material-radio>
                      <material-radio id="seize3" v-model="selectSeize" name="selFreeze" class="radio-horizon"
                        value="1">
                        {{ $t("content.amnseizeact") }}
                      </material-radio>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <label class="form-label ms-0">{{ $t("content.names") }}</label>
                    <div class="input-group">
                      <input v-model="cusNameH_search" type="text" class="form-control" aria-describedby="searchName"
                        readonly />
                      <button class="btn btn-primary" type="button" @click="openDialogCus">
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                      <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                        data-bs-target="#searchNameModal" v-show="false">
                      </button>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                    <material-input type="text" v-model="tkH_search" />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-3 d-flex justify-content-between align-items-center"></div>
                  <div class="col-9 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button id="cardSearch-fn" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="chkSelectHistory">
                        <i class="material-icons material-symbols-outlined">search</i>
                        {{ btnSearch }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                        @click="cancelHistoryBtn">
                        <i class="material-icons material-symbols-outlined">close</i>
                        {{ cancel }}
                      </material-button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row mt-3">
                  <div class="table-responsive">
                    <table class="table">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.amndantinfo") }}</th>
                          <th v-if="selectRdo === '0'">{{ $t("content.lostrunning") }}</th>
                          <th>{{ $t("content.names") }}</th>
                          <th>{{ $t("content.ticketno") }}</th>
                          <th>{{ $t("content.note") }}</th>
                          <th>{{ $t("content.file") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in listhistory" :key="index">
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString((currentPageH - 1) * perPageH + index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ format_datetime(row.createDate) }}</td>
                          <td class="text-sm font-weight-normal" v-if="selectRdo === '0'">
                            {{ row.runningNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.customerName }}</td>
                          <td class="text-sm font-weight-normal">{{ row.refNumber }}</td>
                          <td class="text-sm font-weight-normal">{{ row.remark }}</td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              v-if="row.plDocUid !== '0' && selectRdo !== '0' && filterLastestIndex(row)"
                              @click="getFileTicket(row)" :title="t('content.fileview')">
                              <i class="material-icons material-symbols-outlined">attach_file</i>
                            </material-button>
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              data-bs-toggle="modal" data-bs-target="#attachmentsModal" v-show="false"
                              id="attachmenDialog">
                              <i class="material-icons material-symbols-outlined">attach_file</i>
                            </material-button>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)"
                              v-show="selectRdo === '1' || selectRdo === '0' && filterLastestIndex(row)">
                              <i class=" material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                              data-bs-toggle="modal" data-bs-target="#lookupModal2" id="detailModal">
                            </material-button>
                          </td>
                        </tr>
                        <tr v-if="listhistory.length === 0">
                          <td colspan="10" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="14" style="text-align: right">Total Rows : {{ totalRows_sH }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="listhistory.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageH" :total-items="totalRowsH"
                          :items-per-page="perPageH" @click="onClickHandlerH" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Attachments Dialog -->
        <div id="attachmentsModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                  @click="visible_g = false">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div id="attachmentsImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false">
                  <div class="carousel-indicators" id="demo2">
                  </div>
                  <div class="carousel-inner">
                    <ul className="list-unstyled">
                      <li v-for="(item, index) in images.length" :key="index">
                        <span v-if="index === 0">
                          <div class="carousel-item active">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                        <span v-else>
                          <div class="carousel-item">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target="#attachmentsImages"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#attachmentsImages"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!-- Search Customer Dialog -->
        <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div class="preview-table">
                  <section class="panel">
                    <table class="table table-striped table-responsive">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>{{ $t("content.cnameth") }}</th>
                          <th>{{ $t("content.cnameen") }}</th>
                          <th>{{ $t("content.docno") }}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="row-search">
                          <td></td>
                          <td>
                            <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                          </td>
                          <td>
                            <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                          </td>
                          <td>
                            <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                          </td>
                          <td>
                            <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                              :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                              @click="loadCustomerAfListApi">
                              <i class="material-icons material-symbols-outlined">search</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-for="(row, index) in customerlist" :key="index" @click="selectCusAf(row)">
                          <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                          <td>{{ row.nameTh }}</td>
                          <td>{{ row.nameEn }}</td>
                          <td colspan="2">{{ row.docNumber }}</td>
                        </tr>
                        <tr v-if="customerlist.length === 0">
                          <td colspan="5" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>

              <div class="modal-footer">
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                          :items-per-page="perPageC" @click="onClickHandlerC" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Detail Modal -->
        <TicketDetailModal 
        v-if="workcaseDetail !== null"
        :workcaseDetail="workcaseDetail"
        :images="images"
        :listinfo="listinfo"
        :paymentE="paymentE"
        :paymentL="payment_l"
        :promotionDetail="promotionDetail"
        :depRef="dep_ref"
        :tkStatus="tk_status"
        :intCal="int_cal"
        :intPeriod="int_period"
        :transactionLabel="checkTransaction(workcaseDetail.transactionType)"
        :history="'no'" 
        v-model:fcusdt="fcusdt" 
        :afChangename=af_changename
        :bfChangename=bf_changename
        :transDatePrv=transdate_prv
        @copy="copyBtn"
        @openHistory="NewTab"/>
        



      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, computed, ref, inject, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialRadio from "@/components/MaterialRadio.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import TicketDetailModal from '@/components/TicketDetailModal.vue';

import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"
import nofinger from "@/assets/img/noimg.png"


import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useLostStore } from '@/stores/lost'
import { useFreezeStore } from '@/stores/freeze'
import { useDocumentStore } from '@/stores/document'
import { useDepositStore } from '@/stores/deposit'


const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const storei = useInterestStore()
const storepay = usePaymentGroupStore()
const storelost = useLostStore()
const storefreeze = useFreezeStore()
const storedepo = useDepositStore()
const stored = useDocumentStore()


const { t } = useI18n();
const swal = inject("$swal");

const selectSeize = ref('0');
const selectRdo = ref('0');

const activeTab = ref('tab1');

const save = computed(() => t("buttons.save"));
const cancel = computed(() => t("buttons.canc"));
const savePrint = computed(() => t("buttons.savePrint"));

const btnEdit = computed(() => t("buttons.edit"));
const btnSearch = computed(() => t("buttons.sear"));
const btnFile = computed(() => t('buttons.seed') + t("content.file"));
const confirm = computed(() => t("buttons.conf"));
const startscan = computed(() => t("buttons.sscan"));
const newscan = computed(() => t("buttons.nscan"));

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const currentPageH = ref(1);
const totalRowsH = ref(1);
const perPageH = ref(30);
const totalRows_sH = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')


const listinfo = ref([]);
const workcaseDetail = ref(null);
const info_cat = ref('');
const int_cal = ref(0);
const tk_status = ref('');
const int_period = ref('');
const dep_ref = ref('');
const promotionDetail = ref(null);
const fcusdt = ref(false)
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);


const cusUid_search = ref('');
const cusName_search = ref('');
const customerlist = ref([])

const images = ref([])
const images_l = ref([])

const payment_l = ref([])
const paymentE = ref('');

const loading = ref(false);

const tk_search = ref('');
const listdata = ref([])
const listhistory = ref([])

const cusUidH_search = ref('');
const cusNameH_search = ref('');
const tkH_search = ref('');

const thumb_id = ref('');
const fingerlost_uid = ref('0');
const fingerlost_temp = ref('0');

const Finger1 = ref(null);
const template_1 = ref('');
const template_2 = ref('');
const bmpBase64 = ref('');
const matchResult = ref(0);
const templatef_1 = ref('');
const templatef_2 = ref('');
const bmpBase64f_1 = ref('');
const bmpBase64f_2 = ref('');
const urls = ref([]);
const secugen_lic = ref('');
const idQuality = ref(100);
const count_scan = ref(0);
const count_fg = ref(0);


const regex = /data:.*base64,/
const mimeType = ref("");
const thumb_name = ref('');
const thumb = ref(null);

const otpValue = ref("");
const otpTime = ref(null);
const otpResend = ref(null);
const otpMsg = ref('');
const otpRef = ref('');
const otpValidate = ref(0);
const otpReTime = ref(0);

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const datas = reactive({
  hide: false,
  scanStep: false,
});


const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const formatdt = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

const textInputOptionsdt = {
  format: 'dd/MM/yyyy HH:mm'
};

const onClickHandler = (page) => {
  // console.log('onClickHandler :' + page);
  updatePagination()
};

const onClickHandlerC = (page) => {
  updatePaginationC()
};

const onClickHandlerH = (page) => {

  if (selectRdo.value === '0') {
    updatePaginationLost()
  } else if (selectRdo.value === '1') {
    updatePaginationFreeze()
  }
};


const fmNumber = (val) => {
  return Intl.NumberFormat("en-US").format(val);
};

const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}



function cancelHistoryBtn() {
  cusUidH_search.value = '';
  cusNameH_search.value = '';
  tkH_search.value = '';
  currentPageH.value = 1
  listhistory.value = []
  selectSeize.value = '0';
  selectRdo.value = '0';
  totalRows_sH.value = ''
}

function cancelDataBtn() {
  cusUid_search.value = '';
  cusName_search.value = '';
  tk_search.value = '';
  currentPage.value = 1
  totalRows_s.value = ''
  listdata.value = []
  currentPage.value = 1;
}




const loadDataApi = async (val) => {
  let data = "";

  if (cusUid_search.value !== '' || tk_search.value !== '') {
    currentPage.value = 1
  }
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid:key.groupUid,
    shopUid:key.uid,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value,
    fromDate: "",
    toDate: "",
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storelost.lostSearchFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listdata.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }

}


async function onClickTab(val) {
  if (val === '1') {
    activeTab.value = 'tab1'
    if (cusUid_search.value !== '' || tk_search.value !== '') {
      loadDataApi()
    }
    await setfirstTab()
  } else if (val === '2') {
    activeTab.value = 'tab2'
    if (cusUidH_search.value !== '' || tkH_search.value !== '') {
      chkSelectHistory()
    }
    await setsecondTab()
  }
}

async function setfirstTab() {
  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
}


async function setsecondTab() {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.remove('show', 'active')
  }

  if (document.getElementById("tab2-tab")) {
    document.getElementById("tab2-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab2")) {
    document.getElementById("tab2").classList.add('show', 'active')
  }
}


async function addFile(e) {
  thumb.value = null
  thumb_name.value = ""
  mimeType.value = ""
  if (e.target.files[0] !== undefined) {
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    thumb.value = await toBase64(e.target.files[0])
    thumb_name.value = 'file_' + today
    if (e.target.files[0].type === "image/jpeg") {
      thumb_name.value = thumb_name.value + ".jpg"
      mimeType.value = "image/jpeg"
    } else if (e.target.files[0].type === "image/png") {
      thumb_name.value = thumb_name.value + ".png"
      mimeType.value = "image/png"
    } else if (e.target.files[0].type === 'application/pdf') {
      thumb_name.value = thumb_name.value + ".pdf"
      mimeType.value = "application/pdf"
    }
  }
}

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.replace('data:', '')
    .replace(/^.+,/, ''));
  reader.onerror = reject;
});



async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  if (activeTab.value === 'tab1') {
    await getworkCaseInfo(item.uid)
  } else if (activeTab.value === 'tab2') {
    await getworkCaseInfo(item.workCaseUid)
  }

  if (workcaseDetail.value != null) {
    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }

    if (workcaseDetail.value.deposit) {
      await getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    await detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          await retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
        await calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage()
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();

    }
  }
}

async function viewHistory(item) {
  tkH_search.value = item.refNumber
  selectSeize.value = '0'
  onClickTab('2')
}


async function openDialogCus() {

  if (activeTab.value === 'tab1') {
    cusUid_search.value = ''
    cusName_search.value = ''
  } else if (activeTab.value === 'tab2') {
    cusUidH_search.value = ''
    cusNameH_search.value = ''
  }
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}


async function selectCusAf(item) {
  // console.log('selectCusAf : ' + JSON.stringify(item));
  if (activeTab.value === 'tab1') {
    cusUid_search.value = item.uid
    cusName_search.value = item.nameTh
  } else if (activeTab.value === 'tab2') {
    cusUidH_search.value = item.uid
    cusNameH_search.value = item.nameTh
  }
  document.getElementById("closeModal").click();
}


async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}



async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function updatePagination() {
  listdata.value = []
  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid:key.groupUid,
    shopUid:key.uid,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value,
    fromDate: "",
    toDate: "",
  };

  const payload = data;

  const response = await storelost.lostSearchFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listdata.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
      }
    }
  }

}

async function chkSelectHistory() {
  selectRdo.value = selectSeize.value
  listhistory.value = []
  if (selectRdo.value === '0') {
    await loadLostApi()
  } else if (selectRdo.value === '1') {
    await loadFreezeApi()
  }
}

async function loadLostApi() {
  // if (cusUidH_search.value !== '' || tkH_search.value !== '') {
  //   currentPageH.value = 1
  // }
  currentPageH.value = 1
  let data = "";
  data = {
    index: currentPageH.value - 1,
    size: perPageH.value,
    groupUid:key.groupUid,
    shopUid:key.uid,
    cusUid: cusUidH_search.value,
    refNumber: tkH_search.value,
  };

  const payload = data;
  // console.log("pay : " + JSON.stringify(payload));
  const response = await storelost.lostListFetch(payload);
  // console.log("loadLostApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list;
        totalRowsH.value = response.data.data.ext.total
        totalRows_sH.value = formatNumberString(totalRowsH.value)
      }
    }
  }

}




async function loadFreezeApi() {
  // if (cusUidH_search.value !== '' || tkH_search.value !== '') {
  //   currentPageH.value = 1
  // }
  currentPageH.value = 1
  let data = "";
  data = {
    index: currentPageH.value - 1,
    size: perPageH.value,
    groupUid:key.groupUid,
    shopUid:key.uid,
    cusUid: cusUidH_search.value,
    refNumber: tkH_search.value,
  };

  const payload = data;
  // console.log("pay : " + JSON.stringify(payload));
  const response = await storefreeze.freezeListFetch(payload);
  // console.log("loadFreezeApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list;
        totalRowsH.value = response.data.data.ext.total
        totalRows_sH.value = formatNumberString(totalRowsH.value)
      }
    }
  }

}

async function updatePaginationLost() {
  listhistory.value = []
  let data = "";
  data = {
    index: currentPageH.value - 1,
    size: perPageH.value,
    groupUid:key.groupUid,
    shopUid:key.uid,
    cusUid: cusUidH_search.value,
    refNumber: tkH_search.value,
  };

  const payload = data;
  const response = await storelost.lostListFetch(payload);
  // console.log("UpLostApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list;
        totalRowsH.value = response.data.data.ext.total
        totalRows_sH.value = formatNumberString(totalRowsH.value)
      }
    }
  }

}


async function updatePaginationFreeze() {
  listhistory.value = []
  let data = "";
  data = {
    index: currentPageH.value - 1,
    size: perPageH.value,
    groupUid:key.groupUid,
    shopUid:key.uid,
    cusUid: cusUidH_search.value,
    refNumber: tkH_search.value,
  };

  const payload = data;
  const response = await storefreeze.freezeListFetch(payload);
  // console.log("UpFreeze : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listhistory.value = response.data.data.list;
        totalRowsH.value = response.data.data.ext.total
        totalRows_sH.value = formatNumberString(totalRowsH.value)
      }
    }
  }

}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}

function checkTicketStatus(str) {
  let side = ''
  if (str === 'FINISH') {
    side = 'ปกติ'
  } else if (str === 'FREEZE') {
    side = 'อายัด'
  } else if (str === 'LOST') {
    side = 'หาย'
  }
  return side
}

async function getFileTicket(item) {
  loading.value = true
  images.value = []
    await getFileImg(item.plDocUid, item.plDocUid)
    if (images.value.length > 0) {
      if (images.value[0].title === 'application/pdf') {
        window.open(images.value[0].src, '_blank').focus();
      } else {
        setGallery2()
        document.getElementById("attachmenDialog").click();
      }
      loading.value = false
    }
}

async function getTicketImage() {
  images.value = []
  for (let i = 0; i < images_l.value.length; i++) {
    if (images_l.value[i].imageUid !== "0") {
      await getFileImg(images_l.value[i].imageUid, images_l.value[i].uid)
    }
  }
  if (images.value.length > 0) {
    await nextTick();
    document.getElementById("detailModal").click();
    loading.value = false
  } else {
    let obj = {
      src: noImg,
      thumbnailImageSrc: noImg,
      alt: '',
      title: ''
    }
    images.value.push(obj)
    await nextTick();
    document.getElementById("detailModal").click();
    loading.value = false
  }
}

async function getFileImg(imageUid, uid) {
  let data = "";
  data = {
    shopUid: key.uid,
    uid: imageUid,
  };
  const payload = data;
  // console.log('fi p : ' + JSON.stringify(payload));
  const response = await stored.imgAdminInfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // console.log('fi r : ' + JSON.stringify(response.data));
        const file = getFileFromBase64(response.data.data.data, response.data.data.name)
        const data = URL.createObjectURL(file);
        let obj = {
          src: data,
          thumbnailImageSrc: data,
          alt: '',
          title: file.type,
          uid: uid,
          imageUid: imageUid,
        }
        images.value.push(obj)
      }
    }
  }
}

function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  var ext = fileName.split('.').pop();
  let type = '';
  let imageContent = null
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  } else if (ext === 'pdf') {
    type = 'application/pdf'
  }

  if (type === 'application/pdf') {
    imageContent = atob(string64);
  } else {
    imageContent = atob(trimmedString);
  }

  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }

  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function getworkCaseInfo(id) {
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid: id,
  };
  const payload = data;

  const response = await storewc.workCaseinfoAdminFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}

function setGallery2() {

  var i, y = "";

  for (i = 0; i < images.value.length; i++) {

    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#attachmentsImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#attachmentsImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }

  }
  document.getElementById("demo2").innerHTML = y;
}


async function calIntInt() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }
  data = {
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod

      }
    }
  }
}

async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    uid: item,
  };
  const payload = data;
  // const response = await store.dispatch("unitUpdateFetch", payload);
  const response = await storepay.paymentGroupInfoAdminFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}


function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function filterLastestIndex(item) {
  let bool = true
  let ld = listhistory.value.filter((c) => c.refNumber === item.refNumber);
  if (ld.length > 1) {
    if (ld[ld.length - 1].uid !== item.uid) {
      bool = false
    }
  }
  return bool
}


async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: key.groupUid,
    shopUid: key.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name
        transdate_prv.value = workcase_prv.workItems[0].startTime 
      }
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}

onMounted(() => {

  if (document.getElementById("tab1-tab")) {
    document.getElementById("tab1-tab").classList.add('show', 'active')
  }

  if (document.getElementById("tab1")) {
    document.getElementById("tab1").classList.add('show', 'active')
  }
});


</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-12 {
  font-size: 0.75rem;
}

</style>
